import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { CreativeLanguageListResponse } from '@modules/creatives-link/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  CREATIVES_LINK_PERMISSIONS,
  LOAD_CREATIVE_LANGUAGE_API_URL,
  LOAD_CREATIVE_LANGUAGE_QUERY_KEY,
} from '@modules/creatives-link/constants';

export default function useCreativeLanguageListQuery(
  merchant: Ref<number | undefined>,
  creativeFormatRef: Ref<string | undefined>,
): IContextQueryResult<CreativeLanguageListResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery<CreativeLanguageListResponse>({
    queryKey: [LOAD_CREATIVE_LANGUAGE_QUERY_KEY, merchant, creativeFormatRef],
    queryFn: ({ signal }) => fetchGet<CreativeLanguageListResponse>(
      LOAD_CREATIVE_LANGUAGE_API_URL,
      {
        signal,
        permission: CREATIVES_LINK_PERMISSIONS.SHOW,
        queryParams: {
          merchant: merchant.value,
          format: creativeFormatRef.value,
        },
      },
    ),
    gcTime: 0,
    enabled: computed(() => !!creativeFormatRef.value && !!merchant.value),
  });
}
